import { render, staticRenderFns } from "./inBox.vue?vue&type=template&id=f70ad3e0&scoped=true"
import script from "./inBox.vue?vue&type=script&lang=js"
export * from "./inBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ad3e0",
  null
  
)

export default component.exports